import { Grid } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import webView from 'common/webView';

import Body from './components/Body';
import Footer from './components/Footer';
import FooterButton from './components/FooterButton';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { TEMPLATE_AREA, WEB_VIEW_TEMPLATE_AREA } from './constants';

interface StepLayoutParts {
  Header: typeof Header;
  Sidebar: typeof Sidebar;
  Body: typeof Body;
  Footer: typeof Footer;
  FooterButton: typeof FooterButton;
}

const StepLayout: FCWithChildren & StepLayoutParts = ({ children }) => {
  const { isInWebView } = webView;

  if (isInWebView) {
    return (
      <Grid
        height="100vh"
        overflowX="hidden"
        templateAreas={WEB_VIEW_TEMPLATE_AREA}
        templateRows="max-content max-content 1fr max-content"
      >
        {children}
      </Grid>
    );
  }

  return (
    <Grid
      columnGap={{ '3xl': 'space-240', sm: 'space-40', xl: 'space-120' }}
      height="100vh"
      justifyContent="space-between"
      paddingLeft={{ '3xl': 'space-240', sm: 'space-40', xl: 'space-120' }}
      templateAreas={TEMPLATE_AREA}
      templateColumns="minmax(min-content, 600px) 360px"
      templateRows="max-content 1fr max-content"
    >
      {children}
    </Grid>
  );
};

StepLayout.Header = Header;
StepLayout.Sidebar = Sidebar;
StepLayout.Body = Body;
StepLayout.Footer = Footer;
StepLayout.FooterButton = FooterButton;

export default StepLayout;
